export const environment = {
  production: false,
  apiUrl: "https://api-dev.qpilot.cloud",
  apiNonCoreUrl:
    "https://qpilot-non-core-processes-app-dev-centralus.azurewebsites.net",
  nextimeApiUrl: "https://functions-nextime-dev-centralus.azurewebsites.net/api",
  nextimeApiKey: "",
};
